/**
 * @file     GridRetryButton.tsx
 * @readme   ./CLAUDE.md
 * @purpose  "Try again" for a listing grid whose feed did not respond. A client
 *           island so LocationListingGrid stays a server component: it asks
 *           the router for fresh server data instead of a full reload.
 */
'use client';

import { useTransition } from 'react';
import { useRouter } from 'next/navigation';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '@/core/theme/useAppTheme';

export function GridRetryButton() {
  const router = useRouter();
  const { t } = useTranslation();
  const { theme } = useAppTheme();
  const [pending, startTransition] = useTransition();

  return (
    <Button
      variant="outlined"
      disabled={pending}
      onClick={() => startTransition(() => router.refresh())}
      sx={{
        minHeight: theme.layout.button.md.minHeight,
        px: `${theme.layout.button.md.paddingX - 2}px`,
        textTransform: 'none',
        fontSize: 15,
        fontWeight: 500,
        borderRadius: `${theme.layout.radius.sm}px`,
        color: theme.semanticColors.textPrimary,
        borderColor: theme.semanticColors.borderStrong,
        backgroundColor: theme.semanticColors.surfaceCard,
        '&:hover': { borderColor: theme.semanticColors.interactivePrimary },
      }}
    >
      {pending
        ? t('properties.grid.retrying', { defaultValue: 'Loading' })
        : t('properties.grid.retry', { defaultValue: 'Try again' })}
    </Button>
  );
}
